import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

// Sul form di ricerca: il tasto Invio in un campo esegue la ricerca (come il pulsante Cerca).
// Esclusi: le tendine ng-select (Invio seleziona l'opzione), le aree di testo e i pulsanti.
@Directive({
  selector: '[s1InvioCerca]'
})
export class S1InvioCercaDirective {

  @Output() s1InvioCerca = new EventEmitter<void>();

  @HostListener('keydown.enter', ['$event'])
  onInvio(event: KeyboardEvent): void {

    const target = event.target as HTMLElement;

    if (!target || event.isComposing || target.closest('ng-select, textarea, button')) {
      return;
    }

    event.preventDefault();

    // faccio confermare il valore al campo (es. datepicker, che lo aggiorna su change) prima di cercare
    target.dispatchEvent(new Event('change', { bubbles: true }));
    setTimeout(() => this.s1InvioCerca.emit());

  }

}
